import { getApis } from '../library/Apis';
import { NoProfilePermissions } from '../store/modules/permissions/NoProfile';

export const getOrigem = () => {
  if (document.referrer.trim().length > 0) {
    const url = new URL(document.referrer);
    return url.host;
  }
  return '';
};

const isExternal = () => 'external';

export const getIdentityConfig = () => {
  return {
    authority: getApis().auth.authUrl + '?origin=' + isExternal(),
    client_id: getApis().auth.identityClientId,
    redirect_uri: getApis().auth.redirectUrl,
    silent_redirect_uri: process.env.REACT_APP_SILENT_REDIRECT_URL,
    post_logout_redirect_uri: getApis().auth.logofRedirectUrl,
    audience: 'your audience',
    response_type: 'id_token token',
    automaticSilentRenew: true,
    silentRequestTimeout: 20000, 
    accessTokenExpiringNotificationTime: 60,
    loadUserInfo: false,
    scope: 'openid profile email',
  };
};

export const getMetaDataOIDC = () => {
  return {
    issuer: getApis().auth.tokenUrl,
    jwks_uri: getApis().auth.authUrl + '/.well-known/openid-configuration/jwks',
    authorization_endpoint: getApis().auth.authUrl + '?origin=' + isExternal(),
    token_endpoint: getApis().auth.authUrl + '/connect/token',
    userinfo_endpoint: getApis().auth.authUrl + '/connect/userinfo',
    end_session_endpoint: getApis().auth.authUrl + '/connect/endsession',
    check_session_iframe: getApis().auth.authUrl + '/connect/checksession',
    revocation_endpoint: getApis().auth.authUrl + '/connect/revocation',
    introspection_endpoint: getApis().auth.authUrl + '/connect/introspect',
  };
};

export const getProfileByPrograma = (auth, programa) => {
  return auth.userPermissions[programa] || NoProfilePermissions;
};
